import type { KeyboardEvent } from 'react';

/** Activate a clickable table row with Enter or Space (same as a button). */
export const activateOnEnterOrSpace =
  (activate: () => void) => (event: KeyboardEvent<HTMLTableRowElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      activate();
    }
  };
